export default __webpack_public_path__ + "static/media/advisor-thierry-rosete.0895064a.png";